export const FormValidasiDataSetting = {
  formula_version: [(v) => !!v || "Formula tidak valid"],
  electrical_emission_factor: [
    (v) => !!String(v || "").trim() || "Faktor emisi v1 harus diisi.",
    (v) =>
      !String(v || "").endsWith(",") ||
      "Faktor emisi v1 tidak boleh berakhir dengan koma.",
  ],
  factor_emission_ebt: [
    (v) => !!String(v || "").trim() || "Faktor emisi EBT harus diisi.",
    (v) =>
      !String(v || "").endsWith(",") ||
      "Faktor emisi EBT tidak boleh berakhir dengan koma.",
  ],
  factor_emission_non_ebt: [
    (v) => !!String(v || "").trim() || "Faktor emisi non EBT harus diisi.",
    (v) =>
      !String(v || "").endsWith(",") ||
      "Faktor emisi non EBT tidak boleh berakhir dengan koma.",
  ],
  factor_emission: [
    (v) => !!String(v || "").trim() || "Faktor emisi v2 harus diisi.",
    (v) =>
      !String(v || "").endsWith(",") ||
      "Faktor emisi v2 tidak boleh berakhir dengan koma.",
  ],
  factor_conversion: [
    (v) => !!String(v || "").trim() || "Faktor konversi harus diisi.",
    (v) =>
      !String(v || "").endsWith(",") ||
      "Faktor konversi tidak boleh berakhir dengan koma.",
  ],
  conversion_methane: [
    (v) => !!String(v || "").trim() || "Konversi metana harus diisi.",
    (v) =>
      !String(v || "").endsWith(",") ||
      "Konversi metana tidak boleh berakhir dengan koma.",
  ],
  conversion_co2: [
    (v) => !!String(v || "").trim() || "Konversi CO2 harus diisi.",
    (v) =>
      !String(v || "").endsWith(",") ||
      "Konversi CO2 tidak boleh berakhir dengan koma.",
  ],
};
